package Utils

import myName

val WRAPPED_NAME = listOf<String>(
    "", "קרטון", "ארגז", "ק''ג", "יח'", "משטח", "כללי", "דלי", "שק", "ליטר", "מנה", "קופסא", "שקיות", "צרור", "נספק", "מיכל", "פאקט", "מארז", "רוחב", "אורך", "שטח"
)
val SHORT_NAME = listOf<String>(
    "", "קר'", "אר'", "קג'", "יח'", "מש'", "כל'", "דל'", "שק'", "לי'", "מנ'", "קו'", "שק'", "צר'", "נס'", "מיכ", "פא'", "מא'", "רוח", "אור", "שט"
)

@myName("WrappedName")
enum class WrappedName(val state: Int = 0) {
    NONE(0),
    CARTON(1),
    BOX(2),
    KG(3),
    UNIT(4),
    SURFACE(5),
    SOME_UNIT(6),
    DLI(7),
    SAK(8),
    LITER(9),
    DOSE(10),
    CRATE(11),
    LITTLE_BAGS(12),
    ZROR(13),
    NESPE(14),
    MEICHAL(15),
    /** פאקט — יחידת אריזה / מיכל (container) */
    PAKT(16),
    /** מארז — יחידת אריזה / חבילה (container) */
    MAARAZ(17),
    /** רוחב — dimension; multiplied by a variable length (אורך) when conversion is per line */
    WIDTH(18),
    /** אורך — dimension */
    LENGTH(19),
    /** שטח — area unit */
    AREA(20)

    ;

    override fun toString(): String {
        return MethodName()
    }

    fun convert(ps: Int): WrappedName {
        return when (ps) {
            0 -> {
                NONE
            }
            1 -> {
                CARTON
            }
            2 -> {
                BOX
            }
            3 -> {
                KG
            }
            4 -> {
                UNIT
            }
            5 -> {
                SURFACE
            }
            6 -> {
                SOME_UNIT
            }
            7->  {
                DLI
            }
            8->  {
                SAK
            }
            9->  {
                LITER
            }
            10->  {
                DOSE
            }
            11->  {
                CRATE
            }
            12->  {
                LITTLE_BAGS
            }
            13->  {
                ZROR
            }
            14->  {
                NESPE
            }
            15->  {
                MEICHAL
            }
            16 -> {
                PAKT
            }
            17 -> {
                MAARAZ
            }
            18 -> {
                WIDTH
            }
            19 -> {
                LENGTH
            }
            20 -> {
                AREA
            }

            else -> {
                UNIT
            }
        }
    }
 
    fun MethodName(): String {
        return WRAPPED_NAME[this.state]
    }
    fun shortName(): String {
        return SHORT_NAME[this.state]
    }
    @myName("isContainer")
    fun isContainer():Boolean {
        return when (this) {
            CARTON, BOX, SURFACE, DLI, SAK, DOSE, CRATE, LITTLE_BAGS, MEICHAL, PAKT, MAARAZ -> {
                true
            }
            else -> {
                false
            }
        }
    }
    companion object {
        fun convertFrom(name: String): WrappedName? {
            return WRAPPED_NAME.indexOfFirst { it.compareTo(name) == 0 }.let {
                if (it == -1)
                    null
                else
                    NONE.convert(it)
            }
        }

    }

}